module.exports = __webpack_public_path__ + "img/australia-eye-and-ear-diseases-male.d0470060.png";